import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { connect } from 'react-redux';
import 'react-dynamic-swiper/lib/styles.css';
import { SlideContent } from '../components/slide-content';
import workOrderDays from '../../../utils/workOrderDays';
import { WorkOrderListTop } from '../components/workOrderListTop/work-order-list-top';
import PreviousWorkOrderListContainer from './previous-work-order-list-container';
import getDayAsString from '../../../utils/getDayAsString';
import styled from 'styled-components';
import spacing from 'theme/spacing';
import { PageSwiper } from 'components/Swiper/page-swiper';
const PageSwiperWrapper = styled.div `
  width: 100%;

  .page-swiper {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 750px;
    min-height: calc(100vh - 50px);
    padding-bottom: ${spacing.spacing24};
    text-decoration: none;
  }

  .swiper-slide-active {
    max-height: unset !important;
    overflow: unset !important;
    width: 100% !important;
    overflow: hidden;
  }

  .swiper-slide {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-height: calc(100vh - 50px);
    overflow: hidden;
  }
`;
const WorkOrderListSlideContainer = ({ productList, workOrders, numberOfPrevWorkOrders, languageStrings, }) => {
    const [swiper, updateSwiper] = useState(null);
    const findCorrectProductList = (date) => productList.find(listElement => listElement.serviceDate === date)
        ? productList.find(listElement => listElement.serviceDate === date).products
        : {};
    const { allWorkOrders } = workOrderDays(workOrders);
    const goNext = () => {
        if (swiper !== null) {
            swiper.slideNext();
        }
    };
    const goPrev = () => {
        if (swiper !== null) {
            swiper.slidePrev();
        }
    };
    return (_jsx(PageSwiperWrapper, { children: _jsxs(PageSwiper, { containerClass: "page-swiper", getSwiper: updateSwiper, initialSlide: 1, children: [_jsxs("div", { children: [_jsx(WorkOrderListTop, { hideProductList: true, title: languageStrings.TITLE, onNextClick: goNext }), _jsx(PreviousWorkOrderListContainer, {})] }), allWorkOrders.map((item, index) => (_jsxs("div", { id: `work-order-${index}`, children: [_jsx(WorkOrderListTop, { hideProductList: !item.workOrdersNotDone.length, title: getDayAsString(item.date), productList: findCorrectProductList(item.date), onNextClick: index + 1 < allWorkOrders.length ? goNext : undefined, onPrevClick: goPrev, numberOfElementsPrevPage: index === 0 ? numberOfPrevWorkOrders : undefined }), _jsx(SlideContent, { isWorkOrderListEmpty: item.isWorkOrderListEmpty, areAllWorkOrdersDone: item.areAllWorkOrdersDone, isExternalInstaller: true, workOrdersCancelled: item.workOrdersCancelled, workOrdersDone: item.workOrdersDone, workOrdersNotDone: item.workOrdersNotDone })] }, item.date)))] }) }));
};
const mapStateToProps = (state) => ({
    productList: state.productList.productList,
    workOrders: state.workOrders.workOrders,
    numberOfPrevWorkOrders: state.previousWorkOrders.workOrders.length
        ? state.previousWorkOrders.latestPreviousWorkOrderRequest.totalElements
        : 0,
    isFetchingPrevWorkOrders: state.previousWorkOrders.isFetching,
    languageStrings: state.NOB.PREV_WORKORDERS,
});
export default connect(mapStateToProps)(WorkOrderListSlideContainer);
